const CONVERSION_MS = {
  SECOND: 1000,
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000
};

export const withZeroFormat = (value) => {
  return (value < 10 ? '0' : '')?.concat(value);
};

/**
 * Function to get the hours and minutes from minutes
 * @param {number} minutes
 * @returns Object with hours and minutes
 */
export const getHoursAndMinutesFromMinutes = (minutes = 0) => {
  if (typeof minutes !== 'number') minutes = parseInt(minutes);
  const hours = parseInt(minutes / 60);
  const remainingMinutes = minutes % 60;
  return { hours, minutes: remainingMinutes };
};

/**
 *
 * @param {object} time
 * Returns true is the time is over or otherwise false
 */
export const isTimeOver = (time) => {
  return +time.days + +time.hours + +time.minutes + +time.seconds === 0;
};

export const getRemainigTime = (targetDate, initialDate = new Date()) => {
  const remaining = {
    seconds: '00',
    minutes: '00',
    hours: '00',
    days: '00'
  };

  if (!targetDate) return remaining;
  if (typeof targetDate === 'string') targetDate = new Date(targetDate);

  const initial = new Date(initialDate);

  let diff = targetDate - initial;

  if (diff < 0) return remaining;

  remaining.days = parseInt(diff / CONVERSION_MS.DAY);
  diff -= remaining.days * CONVERSION_MS.DAY;
  remaining.days = withZeroFormat(remaining.days);

  remaining.hours = parseInt(diff / CONVERSION_MS.HOUR);
  diff -= remaining.hours * CONVERSION_MS.HOUR;
  remaining.hours = withZeroFormat(remaining.hours);

  remaining.minutes = parseInt(diff / CONVERSION_MS.MINUTE);
  diff -= remaining.minutes * CONVERSION_MS.MINUTE;
  remaining.minutes = withZeroFormat(remaining.minutes);

  remaining.seconds = parseInt(diff / CONVERSION_MS.SECOND);
  remaining.seconds = withZeroFormat(remaining.seconds);

  return remaining;
};
